export const fr = {
  home: {
    download: {
      ios: 'Télécharger sur l’App Store',
      iosSubtitle: 'iPhone et iPad',
      cta: 'Obtenir',
    },
    location: {
      useMyLocation: 'Utiliser ma position',
      modalBadge: 'Position',
      modalTitle: 'Choisis une ville',
      tabs: {
        cities: 'Villes',
        coords: 'Coordonnées',
      },
      searchPlaceholder: 'Rechercher une ville…',
      refresh: 'Actualiser',
      loading: 'Chargement des villes…',
      empty: 'Aucune ville trouvée.',
      loadError: 'Impossible de charger les villes. Réessaie, s’il te plaît.',
      scrollMore: 'Fais défiler pour en voir plus…',
      coords: {
        latitude: 'Latitude',
        longitude: 'Longitude',
        timezone: 'Fuseau horaire (facultatif)',
        latPlaceholder: 'ex. 43.8563',
        lngPlaceholder: 'ex. 18.4131',
        tzPlaceholder: 'ex. Europe/Paris',
        tzHint: 'Si tu laisses ce champ vide, nous utiliserons le fuseau horaire de ton appareil.',
        apply: 'Utiliser ces coordonnées',
        clear: 'Effacer',
        invalidLat: 'La latitude doit être comprise entre -90 et 90.',
        invalidLng: 'La longitude doit être comprise entre -180 et 180.',
      },
    },
    header: {
      brand: 'Deenly',
      login: 'Se connecter',
      downloadApp: 'Télécharger l’application',
      prayers: {
        fajr: 'Fajr',
        dhuhr: 'Dhuhr',
        asr: 'Asr',
        maghrib: 'Maghrib',
        isha: 'Isha',
      },
    },
    hero: {
      badge: 'Grande mise à jour 2.0',
      titleLine1: 'Tout ton',
      titleGradient: 'Deen, réinventé.',
      subtitle:
        'Un fil de contenus savants, le tajwid guidé par l’IA, la Kaaba en réalité augmentée, la khutba traduite en direct et un mode Enfants protégé par code PIN. Tout ce qu’il te faut, au même endroit.',
    },
    nextPrayer: {
      label: 'Prochaine prière',
      statusOnTime: 'À l’heure',
      startsIn: 'Commence dans',
      meta: {
        locationLabel: 'Sarajevo',
        methodLabel: 'Calcul MWL',
        alertsOn: 'Alertes activées',
        alertsOff: 'Alertes désactivées',
      },
    },
    podcast: {
      badge: 'PODCAST SAVANT',
      titlePrefix: 'Explication du livre :',
      titleMain: 'Riyad as-Salihin',
      author: 'Cheikh Mufti Menk',
    },
    features: {
      title: 'Tout ce qu’il te faut.',
      subtitle: 'De beaux outils, pensés avec soin pour lire, écouter, suivre tes progrès et vivre ton adoration au quotidien.',
      core: {
        dynamicFeed: {
          title: 'Un fil vivant',
          body: 'Des livres, des pages, des hadiths, des versets du jour et des podcasts qui expliquent les textes classiques.',
          bookAddedLabel: 'Livre ajouté',
          bookAddedValue: 'Le Nectar cacheté',
          podcastLabel: 'Podcast',
          podcastValue: 'Tafsir Ibn Kathir',
        },
        mosqueNavigator: {
          badge: 'Navigation en direct',
          title: 'Le chemin vers la mosquée',
          body:
            'Une navigation pas à pas de très haut niveau te guide jusqu’à la mosquée la plus proche. Choisis ta mosquée préférée, suis ton heure d’arrivée et ne rate plus jamais la prière en assemblée.',
          cardTitle: 'Mosquée centrale',
          cardMeta: 'Arrivée : 5 min • À pied',
        },
        dreamInterpreter: {
          title: 'Interprète des rêves par IA',
          body: 'Comprends tes rêves dans une perspective islamique, grâce à notre IA formée sur les textes classiques.',
          cta: 'Demander',
        },
        libraryStats: {
          title: 'Bibliothèque et statistiques',
          body:
            'Lis le Coran en toute fluidité. Appuie longuement sur un verset pour l’ajouter à tes favoris ou pour ouvrir le module de tajwid : récite à voix haute et reçois aussitôt un retour de l’IA sur ta prononciation. Le curseur interactif te montre précisément quand tu termineras le Coran.',
          chips: {
            pages: 'Pages',
            bookmarks: 'Favoris',
            tajweedCheck: 'Vérification du tajwid',
          },
          paceLabel: 'Rythme quotidien',
          paceValue: '20 versets',
          finishLabel: 'Coran terminé dans',
          finishValue: '105 jours',
          longPressLabel: 'Appui long',
          longPressValue: 'Verset 255',
        },
      },
      premium: {
        badge: 'La collection complète',
        title: 'Outils islamiques premium',
        subtitle: 'Une suite complète d’outils performants pour chaque musulman.',
        arQibla: {
          title: 'Qibla et Kaaba en RA',
          body:
            'Trouve la direction exacte de la Qibla grâce à la réalité augmentée. Place une Kaaba virtuelle juste devant toi pour une expérience vraiment immersive.',
          cta: 'Ouvrir la vue RA',
        },
        postureGuide: {
          title: 'Guide des postures',
          body:
            'Pose ton téléphone face à toi. Notre IA détecte tes mouvements et te guide avec précision dans les postures de la prière.',
        },
        liveKhutbah: {
          title: 'Khutba en direct',
          body:
            'Tu assistes à la prière du vendredi à l’étranger ? Reçois sur ton écran la traduction par IA du sermon de l’imam, en temps réel.',
        },
        tajweed: {
          title: 'Récitation du Coran avec l’IA',
          body:
            'Entraîne-toi à réciter. L’IA écoute ton tajwid et te montre aussitôt ce que tu peux améliorer, avec des conseils précis.',
        },
        essentials: {
          title: 'L’essentiel du quotidien',
          body:
            'Et tout le reste : un scanner de codes-barres pour vérifier les ingrédients halal, un tasbih tactile classique et un calculateur de zakat fiable.',
          halalScanner: 'Scanner halal',
          tapTasbih: 'Tasbih tactile',
          zakat: 'Calculateur de zakat',
        },
      },
    },
    kids: {
      badge: 'Deenly Kids',
      title: 'Un bel espace, sûr, pour tes tout-petits.',
      subtitle:
        'Tout ce dont ton enfant a besoin pour apprendre et s’endormir paisiblement, bien à l’abri derrière un code PIN parental.',
      items: {
        pictureBooks: {
          title: 'Livres illustrés',
          body: 'Des histoires interactives, joliment illustrées, qui transmettent les valeurs et la morale de l’islam.',
        },
        lullabies: {
          title: 'Berceuses halal (sans musique)',
          body: 'Des voix apaisantes, enregistrées spécialement pour aider les bébés à s’endormir en douceur. Rigoureusement sans musique.',
        },
        whiteNoise: {
          title: 'Bruit blanc et sons pour dormir',
          body: 'Une sélection de sons apaisants de la nature et de bruits blancs pour les aider à se reposer.',
        },
        games: {
          title: 'Jeux interactifs',
          body: 'Des mini-jeux captivants, sûrs et entièrement éducatifs, parfaitement adaptés aux plus jeunes.',
        },
        pin: {
          title: 'Mode sécurisé par PIN',
          badge: 'Verrouillé',
          body: 'Les enfants restent dans leur espace protégé. Ils ne peuvent pas en sortir sans ton code PIN parental.',
        },
      },
    },
    cta: {
      title: 'Commence ton chemin dès aujourd’hui.',
      subtitle: 'Rejoins des millions de musulmans à travers le monde qui construisent de meilleures habitudes au quotidien avec Deenly.',
      ios: 'Télécharger pour iOS',
      android: 'Obtenir sur Android',
    },
    footer: {
      copyright: '© 2023 Deenly. Tous droits réservés.',
      links: {
        privacy: 'Politique de confidentialité',
        terms: 'Conditions d’utilisation',
        contact: 'Contact',
      },
    },
  },
  legal: {
    privacy: {
      metaTitle: 'Confidentialité et conditions • Deenly',
      header: {
        badge: 'Document légal',
        back: 'Retour',
      },
      hero: {
        titlePrefix: 'Politique de ',
        titleGradient: 'confidentialité.',
        subtitle:
          'Nous pensons que tes données te regardent, toi, et pas nous. Notre principe : en collecter le moins possible, tout en t’offrant une expérience de très haut niveau.',
        lastUpdatedLabel: 'Dernière mise à jour',
        badgeIcon: 'solar:shield-check-linear',
        calendarIcon: 'solar:calendar-linear',
      },
      languageLabel: 'Langue',
      lang: {
        en: 'English',
        bs: 'Bosanski',
        de: 'Deutsch',
        nl: 'Nederlands',
        fr: 'Français',
      },
      search: {
        title: 'Rechercher',
        placeholder: 'Rechercher (ex. « données », « compte », « tiers »)',
        found: 'Sections trouvées',
        clear: 'Effacer',
        tocTitle: 'Sommaire',
        tocHint: 'Accède directement à une section.',
        emptyTitle: 'Aucun résultat',
        emptyBody:
          'Aucune section ne correspond à ta recherche. Essaie avec un autre mot-clé.',
        backToTop: 'Haut de page',
        backHome: 'Retour à l’accueil',
      },
      tldr: {
        title: 'L’essentiel',
        icon: 'solar:bolt-linear',
        cards: [
          {
            icon: 'solar:eye-closed-linear',
            title: 'Jamais de publicité',
            body: 'Nous ne vendons pas tes données aux annonceurs. Deenly vit entièrement de ses abonnements premium.',
          },
          {
            icon: 'solar:map-point-linear',
            title: 'Position en local',
            body: 'Les horaires de prière sont calculés directement sur ton appareil. Nous ne suivons jamais tes déplacements.',
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Synchronisation chiffrée',
            body: 'Tes favoris et tes statistiques personnelles sont chiffrés, aussi bien pendant leur transfert que sur nos serveurs.',
          },
          {
            icon: 'solar:smile-circle-linear',
            title: 'Les enfants en sécurité',
            body: 'Le mode Enfants respecte la loi COPPA et ne collecte absolument aucune donnée de télémétrie.',
          },
        ],
      },
      toc: [
        { id: 'tldr', label: 'L’essentiel' },
        { id: 'collection', label: 'Collecte' },
        { id: 'usage', label: 'Utilisation des données' },
        { id: 'kids', label: 'Confidentialité des enfants' },
        { id: 'sharing', label: 'Partage' },
        { id: 'security', label: 'Sécurité' },
        { id: 'contact', label: 'Nous contacter' },
      ],
      collection: {
        title: 'Les informations que nous collectons',
        intro:
          'Nous nous engageons à collecter le minimum de données. Voici exactement ce qui se passe quand tu utilises Deenly.',
        items: [
          {
            icon: 'solar:key-minimalistic-2-linear',
            title: 'Identité de l’appareil (UUID)',
            bodyParts: [
              { text: 'Au premier lancement, l’application génère un ', highlight: false },
              { text: 'UUID', highlight: true },
              { text: ' aléatoire et le conserve en sécurité dans la session de ton appareil (Keychain / Keystore). Cet identifiant sert uniquement à enregistrer ton appareil auprès de nos serveurs. Il ne quitte jamais l’appareil, sauf pour s’authentifier auprès de notre API.', highlight: false },
            ],
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Jeton de session (JWT)',
            bodyParts: [
              { text: 'Après l’enregistrement, notre serveur émet un ', highlight: false },
              { text: 'JWT', highlight: true },
              { text: ' conservé exclusivement dans la session de ton appareil. Toutes les requêtes suivantes vers l’API utilisent ce jeton. Il n’y a pas de connexion classique avec nom d’utilisateur et mot de passe : ton identité, c’est la session de ton appareil.', highlight: false },
            ],
          },
          {
            icon: 'solar:routing-2-linear',
            title: 'Données de position (sur l’appareil)',
            bodyParts: [
              { text: 'Elles servent uniquement à calculer avec précision les horaires de prière et la direction de la Qibla. Le calcul se fait ', highlight: false },
              { text: 'localement sur ton appareil', highlight: true },
              { text: '. Nous ne conservons ni ne transmettons jamais l’historique de tes positions.', highlight: false },
            ],
          },
          {
            icon: 'solar:mic-2-linear',
            title: 'Accès au microphone',
            body:
              'Il sert au vérificateur de récitation par IA et à la traduction de la khutba en direct. La reconnaissance vocale s’exécute sur ton appareil : l’audio lui-même n’est jamais envoyé, enregistré ni conservé par nos soins. Ce qui peut quitter l’appareil, c’est du texte, comme expliqué ci-dessous.',
          },
          {
            icon: 'solar:document-text-linear',
            title: 'Traitement de texte par IA (transcriptions et rêves)',
            bodyParts: [
              { text: 'Certaines fonctions d’IA demandent plus de puissance de calcul qu’un téléphone n’en possède. Quand tu utilises la traduction de la khutba en direct, le ', highlight: false },
              { text: 'texte reconnu de chaque phrase', highlight: true },
              { text: ' (jamais l’audio) est envoyé par une connexion chiffrée à nos serveurs, puis transmis à un partenaire de confiance spécialisé dans le traitement par IA, qui produit la traduction et le résumé de fin de khutba. Les descriptions de rêves que tu soumets à l’interprète sont traitées de la même manière. Ces requêtes ne contiennent que la session de ton appareil, ni ton nom ni tes coordonnées. Ton historique de khutbas reste uniquement sur ton appareil ; les traductions sont gardées en cache sur nos serveurs pendant 30 jours au maximum, afin que toute une assemblée qui suit la même khutba soit servie instantanément ; les transcriptions partagées en « salle » sont supprimées de nos serveurs en quelques heures.', highlight: false },
            ],
          },
        ],
      },
      usage: {
        title: 'Comment nous utilisons les données',
        intro:
          'Les données que nous collectons servent strictement à améliorer ton expérience. Nous ne faisons aucun profilage comportemental.',
        cards: [
          {
            icon: 'solar:cloud-sync-linear',
            title: 'Synchronisation dans le cloud',
            body:
              'Synchronise sans effort tes favoris du Coran, tes statistiques quotidiennes et tes réglages sur tous tes appareils.',
          },
          {
            icon: 'solar:magic-stick-3-linear',
            title: 'Traitement des fonctions d’IA',
            body:
              'La traduction de la khutba phrase par phrase, les résumés de khutba et les interprétations de rêves sont produits à partir de texte envoyé à nos serveurs et à un partenaire de confiance spécialisé dans le traitement par IA. Les requêtes sont liées uniquement à la session de ton appareil et ne servent jamais à établir ton profil.',
          },
        ],
      },
      kids: {
        title: 'Confidentialité du mode Enfants',
        intro:
          'Nous prenons la vie privée des mineurs extrêmement au sérieux. L’espace Enfants est un environnement très sécurisé, conçu pour fonctionner d’abord hors ligne.',
        badge: {
          icon: 'solar:star-fall-minimalistic-2-linear',
          label: 'Disposition spéciale',
        },
        items: [
          {
            icon: 'solar:shield-check-linear',
            text: 'Aucun suivi ni script d’analyse dans le mode Enfants.',
          },
          {
            icon: 'solar:document-text-linear',
            text: 'Entièrement conforme à la loi COPPA et au RGPD-K.',
          },
          {
            icon: 'solar:lock-password-linear',
            text: 'Aucun lien externe ni achat sans le code PIN parental.',
          },
        ],
      },
      sharing: {
        title: 'Partage des données',
        body:
          'Nous ne vendons, ne louons ni n’échangeons tes informations personnelles avec des tiers. Nous ne partageons des informations qu’avec des partenaires d’infrastructure de grande confiance, dans le seul but de faire fonctionner l’application. Parmi eux, un partenaire de traitement par IA qui reçoit uniquement le texte nécessaire à une fonction (une phrase de khutba à traduire, une description de rêve à interpréter), jamais ton identité. Ces partenaires sont liés par des accords de confidentialité stricts et ne peuvent pas utiliser tes données à leurs propres fins, y compris pour la publicité ou pour entraîner des modèles sur tes contenus.',
      },
      security: {
        title: 'Mesures de sécurité',
        body:
          'Ta confiance est notre bien le plus précieux. Nous mettons en œuvre des mesures de sécurité à la pointe pour protéger tes données. Toutes les communications sont sécurisées par chiffrement TLS. Ton UUID et ton JWT sont conservés uniquement dans la session sécurisée de ton appareil (Keychain sur iOS, Keystore sur Android) et ne sont jamais accessibles en dehors de celui-ci.',
      },
      contactCta: {
        title: 'Une question sur ta vie privée ?',
        subtitle: 'Notre équipe chargée de la confidentialité est là pour t’aider.',
        button: 'Contacter l’équipe confidentialité',
        icon: 'solar:letter-linear',
      },
      footerNote: 'Tous droits réservés. Conçu avec une intention sincère.',
      footer: {
        links: {
          terms: 'Conditions',
          privacy: 'Confidentialité',
          cookies: 'Cookies',
        },
      },
    },
  },
};
